export const CODE_NATIONAL = "HVE2";

const exports = { codeNational: CODE_NATIONAL };
export default exports;
